import { render, staticRenderFns } from "./AmountIoListCard.vue?vue&type=template&id=4c83d052&"
import script from "./AmountIoListCard.vue?vue&type=script&lang=js&"
export * from "./AmountIoListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports